import React, { useEffect, useState } from "react";
import Fancybox from "../../Fancybox";
import { useParams } from "react-router-dom";

const GalleryDetail = () => {
    const { encryptedId } = useParams();
    const [album, setAlbums] = useState([]);
    useEffect(() => {
        const fetchGallery = async () => {
            const response = await window.apiClient.get(`/data/get/gallery/${encryptedId}`);
            setAlbums(response.data);
        };
        fetchGallery();
    }, [encryptedId]);
    if (!album.nama_album) return <div>Loading...</div>;
    return (
        <section className="py-8 bg-gray-100">
            <div className="container px-4 mx-auto">
                <div className="md:col-span-2 lg:col-span-3">
                    <h2 className="mb-4 text-2xl font-bold text-center uppercase">{album.nama_album}</h2>
                    <h3 className="text-lg text-center text-gray-500">{album.created_date.substring(0, 10)}</h3>
                </div>

                <Fancybox options={{
                    Carousel: {
                        infinite: false
                    }
                }}>
                    <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
                        {album.images && album.images.length > 0 ? (
                            album.images.map((row, index) => (
                                <div key={index} className="gallery-item">
                                    <a
                                        href={`http://admin.sman2amlapura.sch.id/images/image_album/${row.url_image}`}
                                        data-fancybox="group"
                                        data-caption={row.caption_image}
                                        className="block"
                                    >
                                        <img
                                            src={`http://admin.sman2amlapura.sch.id/images/image_album/${row.url_image}`}
                                            alt={row.caption_image || "Image"}
                                            className="w-full h-auto rounded-lg shadow-md transition-transform duration-200 hover:scale-105"
                                        />
                                    </a>
                                </div>
                            ))
                        ) : (
                            <p className="text-center md:col-span-2 lg:col-span-3">Tidak ada gambar dalam album ini.</p>
                        )}
                    </div>
                </Fancybox>
            </div>
        </section>
    );
};

export default GalleryDetail;
